<template>
  <div>
    <div class="se-m-b-20">首页 > 知识库列表</div>
    <div class="se-flex">
      <div class="se-menu">
        <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
          style="width: 100%; height: 100%"
          active-text-color="#e44352"
          background-color="#fbfeff"
          @select="handleOpen"
        >
          <el-menu-item index="1">
            <span slot="title">全部</span>
          </el-menu-item>
          <el-menu-item
            v-for="(v, i) in knowledgeDirList"
            :key="i"
            :index="String(i + 2)"
          >
            <span slot="title">{{ v.dirName }}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="se-list" v-loading="loading">
        <el-empty
          class="se-center"
          v-if="knowledgeList.length === 0"
          description="暂无数据"
        ></el-empty>

        <div
          class="se-item se-flex jcsb aic cp"
          v-for="(item, i) in knowledgeList"
          :key="i"
          @click="go(item.fileUrl, item.fileType, item.fileName)"
        >
          <div class="se-flex aic">
            <img
              src="../../assets/icons/ding.png"
              style="width: 14px; height: 14px"
            />
            <!-- <img
            :src="item.fileUrl?item.fileUrl:'../../assets/icons/ding.png'"
            style="width:14px;height:14px;"
          /> -->
            <div class="ft-14-000 se-m-l-15">
              {{ item.fileName }}.{{ item.fileType }}
            </div>
          </div>
          <div class="ft-14-999">
            {{ item.createdTime }}
          </div>
        </div>
        <div class="se-flex-h-c se-p-t-20 se-p-b-20">
          <el-pagination
            v-if="knowledgeList.length !== 0"
            background
            @current-change="currentChange"
            :current-page="pageNum"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      dirId: null,
      total: 0,
      knowledgeList: [],
      knowledgeDirList: [],
      loading: false,
    };
  },
  mounted() {
    this.getKnowledgeList();
    this.getKnowledgeDir();
  },

  methods: {
    // 菜单
    handleOpen(e) {
      this.knowledgeList = [];
      // console.log(e);
      if (e === "1") {
        this.dirId = null;
        this.getKnowledgeList();
      } else {
        let index = Number(e) - 2;
        // console.log(index, "index");
        this.dirId = this.knowledgeDirList[index].id;
        this.getKnowledgeList();
      }
    },

    go(url, type, name) {
      // this.openUrl(url, `${name}.${url.split(".")[url.split(".").length - 1]}`);
      // let src = JSON.stringify(url);
      // let routeData = this.$router.resolve({
      //   name: "knowledgeInfo",
      //   query: { url: src, type, name },
      // });
      // window.open(routeData.href, "_blank");
      const typeList = ["ppt", "pptx", "xlsx", "xls", "doc", "docx"];
      if (typeList.includes(type)) {
        open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
        // open(`https://view.xdocin.com/view?src=${encodeURIComponent(url)}`)
      } else {
        open(url);
      }
    },
    openUrl(url, name) {
      const x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";
      x.onload = () => {
        const newUrl = window.URL.createObjectURL(x.response);
        // console.log("newUrl", newUrl);
        this.downLoad(newUrl, name);
      };
      x.send();
    },

    downLoad(file, name) {
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = file;
      // console.log(name);
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    //切换分页
    currentChange(val) {
      this.pageNum = val;
      this.getKnowledgeList();
    },

    //获取知识库列表
    getKnowledgeList() {
      this.loading = true;
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        dirId: this.dirId,
        status: 1,
      };
      this.$http
        .get("server/portal/home/listKnowledgedir", data)
        .then((res) => {
          this.knowledgeList = res.rows;
          this.total = res.total;
        });
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },

    // 获取知识库分类
    getKnowledgeDir() {
      this.$http.get("server/portal/home/listCmsKnowledgedir").then((res) => {
        this.knowledgeDirList = res.rows;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.se-list {
  background-color: #fff;
  width: 100%;
  min-height: calc(100vh - 40px - 60px - 150px - 40px);
  padding: 0;
  border-radius: 10px;
}

.se-menu {
  min-height: calc(100vh - 40px - 60px - 150px - 40px);
  width: 260px;
}

.se-item {
  padding: 30px 40px;
  border-bottom: 1px solid #eee;
}

.se-item:hover {
  background-color: #f1f1f1;
}

/deep/ .el-menu-item.is-active {
  background-color: #fff !important;
}

/deep/ .el-menu-item:hover {
  background-color: #fff !important;
}

/deep/ .el-menu-item {
  text-align: center;
}

.se-center {
  transform: translateX(50%);
  transform: translateY(50%);
}
</style>
